import React from 'react';
import SuperTooltipRenderer from './SuperTooltipRenderer';
import { useSuperTooltipVM } from './super-tooltip.viewModel';
import { ReactComponent as Star } from './assets/star.svg';
import { SuperTooltipTemplateId } from './generated';

export interface SuperTooltipProps {
  templateId: SuperTooltipTemplateId;
  slideIndex?: number;
  hideNavigation?: boolean;
}

const SuperTooltip: React.FC<SuperTooltipProps> = ({
  templateId,
  slideIndex,
  hideNavigation,
}) => {
  const vm = useSuperTooltipVM({
    templateId,
    slideIndex,
    hideNavigation: hideNavigation ?? false,
  });

  return (
    <>
      <Star
        onClick={vm.onOpen}
        width="22"
        height="22"
        style={{ cursor: 'pointer' }}
      />

      <SuperTooltipRenderer {...vm} />
    </>
  );
};

export default SuperTooltip;
